/* Skinsy story — the product page's compare slider and feel carousel, on a
   brand collection page.

   Ported from skinsy-pdp.js, minus the finish state: there is no swatch rail
   here, so the slider's skinned half is whatever the section rendered
   server-side and the only state is the handle position and the feel index.
   Everything that is a behaviour on the product page is the same behaviour
   here — intent decided on the first few pixels, one auto-sweep on first
   sight, slides loaded only as they are reached, rails that drag under a
   mouse. */

(function () {
  'use strict';

  var PRESENCE = 0.937;

  document.querySelectorAll('[data-skinsy-story]').forEach(function (root) {
    var $ = function (sel, ctx) { return (ctx || root).querySelector(sel); };
    var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); };

    /* Both halves are server-rendered; fit them once so two generations of
       render sit the device at one size. */
    if (window.skinsyFit) {
      $$('.sk-diff__bare[data-has-render], .sk-diff__skin[data-has-render]').forEach(function (el) {
        window.skinsyFit.fitSide(el, PRESENCE);
      });
    }

    /* ---------------- the difference: drag + one auto-sweep ---------------- */

    var diff = $('[data-diff]');
    if (diff) {
      var pct = 50;
      var paint = function () {
        $$('[data-diff-after]').forEach(function (el) { el.style.clipPath = 'inset(0 0 0 ' + pct + '%)'; });
        $$('[data-diff-handle]').forEach(function (el) { el.style.left = pct + '%'; });
        var bareOp = Math.max(0, Math.min(1, (pct - 14) / 16));
        var finOp = Math.max(0, Math.min(1, (86 - pct) / 16));
        $$('[data-diff-label-bare]').forEach(function (el) { el.style.opacity = bareOp; });
        $$('[data-diff-label-finish]').forEach(function (el) { el.style.opacity = finOp; });
      };
      var setPct = function (v) { pct = Math.max(3, Math.min(97, v)); paint(); };
      paint();

      var pending = null;
      var dragging = false;
      var userTouched = false;
      var raf = null;

      var updateDiff = function (clientX) {
        var r = diff.getBoundingClientRect();
        setPct(((clientX - r.left) / r.width) * 100);
      };

      diff.addEventListener('pointerdown', function (e) {
        pending = { x: e.clientX, y: e.clientY, id: e.pointerId };
        userTouched = true;
        if (raf) cancelAnimationFrame(raf);
      });
      diff.addEventListener('pointermove', function (e) {
        if (dragging) { updateDiff(e.clientX); return; }
        if (!pending) return;
        var dx = Math.abs(e.clientX - pending.x);
        var dy = Math.abs(e.clientY - pending.y);
        if (dx > 6 && dx > dy) {
          try { diff.setPointerCapture(pending.id); } catch (err) {}
          dragging = true;
          updateDiff(e.clientX);
        } else if (dy > 6) {
          pending = null;
        }
      });
      var endDiff = function () { pending = null; dragging = false; };
      diff.addEventListener('pointerup', endDiff);
      diff.addEventListener('pointercancel', endDiff);
      diff.addEventListener('dragstart', function (e) { e.preventDefault(); });

      var autoSweep = function () {
        var start = performance.now();
        var dur = 2600;
        var tick = function (now) {
          if (userTouched) return;
          var t = Math.min(1, (now - start) / dur);
          setPct(50 - 24 * Math.sin(t * 2 * Math.PI));
          if (t < 1) raf = requestAnimationFrame(tick);
          else setPct(50);
        };
        raf = requestAnimationFrame(tick);
      };
      if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        var swept = false;
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting && en.intersectionRatio > 0.45 && !swept) {
              swept = true;
              autoSweep();
              io.disconnect();
            }
          });
        }, { threshold: [0, 0.45, 1] });
        io.observe(diff);
      }
    }

    /* ---------------- the feel: swipeable macro carousel ---------------- */

    var feel = $('[data-feel]');
    var feelTrack = $('[data-feel-track]');
    var slides = $$('[data-feel-slide]');
    var texIdx = 0;

    var goFeel = function (i) {
      texIdx = i;
      if (feelTrack) {
        feelTrack.classList.remove('is-dragging');
        feelTrack.style.transform = 'translateX(' + (-i * 100) + '%)';
      }
      $$('[data-feel-dot]').forEach(function (d) {
        d.setAttribute('aria-current', String(Number(d.dataset.feelDot) === i));
      });
      /* Only slides the visitor actually reaches are loaded — srcset first,
         so a phone never pays for the desktop crop. */
      var slide = slides[i];
      if (slide) {
        var img = $('img[data-src]', slide);
        if (img) {
          if (img.dataset.srcset) { img.srcset = img.dataset.srcset; img.removeAttribute('data-srcset'); }
          img.src = img.dataset.src;
          img.removeAttribute('data-src');
        }
      }
    };

    root.addEventListener('click', function (e) {
      var dot = e.target.closest('[data-feel-dot]');
      if (dot) goFeel(Number(dot.dataset.feelDot));
    });

    if (feel && feelTrack && slides.length) {
      var fp = null;
      var fDragging = false;
      var fDrag = 0;
      feel.addEventListener('pointerdown', function (e) {
        fp = { x: e.clientX, y: e.clientY, id: e.pointerId };
      });
      feel.addEventListener('pointermove', function (e) {
        if (!fp) return;
        var dx = e.clientX - fp.x;
        var dy = e.clientY - fp.y;
        if (fDragging) {
          fDrag = dx;
          feelTrack.style.transform = 'translateX(calc(' + (-texIdx * 100) + '% + ' + dx + 'px))';
          return;
        }
        if (Math.abs(dx) > 6 && Math.abs(dx) > Math.abs(dy)) {
          try { feel.setPointerCapture(fp.id); } catch (err) {}
          fDragging = true;
          feelTrack.classList.add('is-dragging');
          fDrag = dx;
        } else if (Math.abs(dy) > 6) {
          fp = null;
        }
      });
      var endFeel = function () {
        fp = null;
        if (!fDragging) return;
        fDragging = false;
        var ni = texIdx;
        if (fDrag < -40 && texIdx < slides.length - 1) ni = texIdx + 1;
        else if (fDrag > 40 && texIdx > 0) ni = texIdx - 1;
        fDrag = 0;
        goFeel(ni);
      };
      feel.addEventListener('pointerup', endFeel);
      feel.addEventListener('pointercancel', endFeel);
      /* A mouse dragging across an <img> starts the browser's own drag-and-
         drop and the pointer sequence dies with it. */
      feel.addEventListener('dragstart', function (e) { e.preventDefault(); });
    }

    /* ---------------- mouse drag on the review rail ---------------- */

    $$('.sk-reviews__rail').forEach(function (rail) {
      var drag = null;
      var moved = false;
      rail.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        drag = { x: e.clientX, left: rail.scrollLeft, id: e.pointerId };
        moved = false;
      });
      rail.addEventListener('pointermove', function (e) {
        if (!drag) return;
        var dx = e.clientX - drag.x;
        if (!moved && Math.abs(dx) < 5) return;
        if (!moved) {
          moved = true;
          try { rail.setPointerCapture(drag.id); } catch (err) {}
          rail.classList.add('is-dragging');
        }
        rail.scrollLeft = drag.left - dx;
      });
      var endDrag = function () {
        if (!drag) return;
        drag = null;
        rail.classList.remove('is-dragging');
      };
      rail.addEventListener('pointerup', endDrag);
      rail.addEventListener('pointercancel', endDrag);
      rail.addEventListener('click', function (e) {
        if (!moved) return;
        moved = false;
        e.preventDefault();
        e.stopPropagation();
      }, true);
      rail.addEventListener('dragstart', function (e) { e.preventDefault(); });
    });
  });
})();
